import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import OtherApplications from "./OtherApplications";
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose, withHandlers, withProps, setPropTypes } from 'recompose';
import PropTypes from 'prop-types';
import { loadOtherApplications } from "../../enhancer";
import { permissionsSelector } from '@applyboard/ab-common';
import { applicationOtherApplicationsSelector, applicationOtherApplicationsLoadingSelector, applicationOtherApplicationsLoadedSelector } from "../../../../store/selectors/application";
var enhancer = compose(connect(createStructuredSelector({
  applications: applicationOtherApplicationsSelector,
  loading: applicationOtherApplicationsLoadingSelector,
  loaded: applicationOtherApplicationsLoadedSelector,
  permissions: permissionsSelector
}), function (dispatch) {
  return {
    load: function load() {
      return dispatch(loadOtherApplications.apply(void 0, arguments));
    }
  };
}), withHandlers({
  onOpen: function onOpen(_ref) {
    var loaded = _ref.loaded,
      loading = _ref.loading,
      load = _ref.load;
    return function () {
      if (loading || loaded) return;
      load();
    };
  }
}), withProps(function (_ref2) {
  var permissions = _ref2.permissions,
    applications = _ref2.applications;
  return {
    show_ids: permissions ? permissions.show_ids : false,
    applications: applications.filter(function (application) {
      return application.paid;
    })
  };
}), setPropTypes({
  applications: PropTypes.array,
  load: PropTypes.func,
  loaded: PropTypes.bool,
  loading: PropTypes.bool,
  permissions: PropTypes.object
}));
export default enhancer(OtherApplications);